export default __webpack_public_path__ + "locales/ro/PaymentsEnterprise.json?hash=4132af55f09aef514aee27ea63e58a03";